import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { ArrowIcon, BreetIcon } from 'BreetAssets';
import { getTeamMemberRoleLabel } from 'BreetHelpers';

import type { IAvailableAccount } from './DialogSwitchUserAccount.helpers';

const AvailableAccount = ({
	accountName,
	accountRole,
	onClick,
	isLoading,
	isActive,
	className,
	lastChild,
}: IAvailableAccount) => (
	<Button
		variant='native'
		className={classNameMerger(
			'switch-account-list-item bg-primary-400-hover',
			!lastChild && 'border-bottom-dark-navy',
			isActive && 'active',
			className
		)}
		onClick={onClick}
	>
		<div className='list-item-left'>
			<BreetIcon
				hideText
				className='logo-icon'
			/>
			<div className='list-item-txt'>
				<Typography
					as='h6'
					className='color-tertiary-400'
				>
					{accountName}
				</Typography>
				<Typography className='color-primary-50'>{getTeamMemberRoleLabel(accountRole)}</Typography>
			</div>
		</div>
		{isLoading && !isActive ? (
			<div className='button-spinner' />
		) : (
			<>
				{isActive ? (
					<span className='list-item-badge'>Current</span>
				) : (
					<ArrowIcon
						variant='arrowRight'
						className='svg-light arrow-right'
					/>
				)}
			</>
		)}
	</Button>
);

export default AvailableAccount;
